/**
 * @typedef {{ id: *, title: string }} IndustryPropertyOption
 */

/**
 * @param {string} token
 * @param {IndustryPropertyOption[]} options
 * @returns {IndustryPropertyOption|null}
 */
const matchTokenToOption = (token, options) => {
    const trimmed = token?.trim() ?? '';
    if (!trimmed) {
        return null;
    }
    const exact = options.find((o) => o.title === trimmed);
    if (exact) {
        return exact;
    }
    const upper = trimmed.toUpperCase();
    return options.find((o) => (o.title ?? '').trim().toUpperCase() === upper) ?? null;
};

/**
 * @param {string} rawValue
 * @returns {string[]}
 */
export const splitPredefinedImportTokens = (rawValue) =>
    (rawValue ?? '')
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean);

/**
 * @param {string} rawValue
 * @param {IndustryPropertyOption[]} options
 * @param {{ isMultiSelect: boolean }} config
 * @returns {{
 *   resolved: boolean,
 *   imputedDisplay: string|undefined,
 *   apiValue: string|string[]|undefined,
 *   unresolvedTokens: string[],
 * }}
 */
export const resolvePredefinedPropertyValues = (rawValue, options, {isMultiSelect}) => {
    const tokens = isMultiSelect ? splitPredefinedImportTokens(rawValue) : [(rawValue ?? '').trim()].filter(Boolean);

    if (!tokens.length) {
        return {resolved: true, imputedDisplay: undefined, apiValue: undefined, unresolvedTokens: []};
    }

    const matched = [];
    const unresolvedTokens = [];

    for (const token of tokens) {
        const option = matchTokenToOption(token, options);
        if (option) {
            matched.push(option);
        } else {
            unresolvedTokens.push(token);
        }
    }

    if (unresolvedTokens.length) {
        return {resolved: false, imputedDisplay: undefined, apiValue: undefined, unresolvedTokens};
    }

    const titles = matched.map((o) => o.title);
    const imputedDisplay = titles.join(',');
    const apiValue = isMultiSelect ? titles : titles[0];

    return {resolved: true, imputedDisplay, apiValue, unresolvedTokens: []};
};
